module.exports = __webpack_public_path__ + "static/media/overpass-bold.c6179bc8.woff";